var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4255 0.702393C9.75094 1.02783 9.75094 1.55547 9.4255 1.8809L4.25291 7.29757C3.92747 7.623 3.39984 7.623 3.0744 7.29757L0.5744 4.79757C0.248963 4.47214 0.248963 3.9445 0.5744 3.61906C0.899837 3.29362 1.42747 3.29362 1.75291 3.61906L3.66366 5.5298L8.24699 0.702393C8.57243 0.376956 9.10006 0.376956 9.4255 0.702393Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3850c20d19a43898def207d587363a30.svg";
export { ForwardRef as ReactComponent };